import React from "react";
import "./Testimonial.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { Pagination } from "swiper";
import "swiper/css/pagination";
import profilePic1 from "../../img/profile1.jpg";
import profilePic2 from "../../img/profile2.jpg";
import profilePic3 from "../../img/profile3.jpg";
import profilePic4 from "../../img/profile4.jpg";

const Testimonial = () => {
  const clients = [
    {
      img: profilePic1,
      review:
        "Elara:  Sahil Thakur is an incredible web developer! He did a fantastic job with my project and delivered it on time, exceeding all my expectations. I would highly recommend him to anyone!",
    },
    {
      img: profilePic2,
      review:
        "Nikki:  Sahil Thakur is a seasoned web developer who is excellent to work with. He quickly created a stunning website for me; his expertise and efficiency are commendable!",
    },
    {
      img: profilePic3,
      review:
        "Charlotte:  I'm so happy with Sahil Thakur's web development skills! He completed my project with such excellence and on schedule.",
    },
    {
      img: profilePic4,
      review:
        "Steve:  Sahil Thakur's web development skills are top-notch! He completed my project with excellence and on schedule.",
    },
  ];

  return (
    <div className="t-wrapper" id="testimonial">
      <div className="t-heading">
        <span>Clients always get </span>
        <span>Exceptional Work </span>
        <span>from me...</span>
      <div className="blur t-blur1" style={{ background: "var(--purple)" }}></div>
      <div className="blur t-blur2" style={{ background: "skyblue" }}></div>

      </div>
      <Swiper
        // install Swiper modules
        modules={[Pagination]}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {clients.map((client, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="testimonial">
                <img src={client.img} alt="" />
                <span>{client.review}</span>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Testimonial;
